import { Button } from "components/ui/button/Button";
import "./terms-and-conditions.scss";
import { useSelector } from "react-redux";
import { getStepData } from "pages/application/question/questionSlice";
import { getCurrentUserApplicationId } from "features/authSlice";
import { useSetApplicationStepAnswerMutation } from "pages/application/applicationService";
import { useEffect, useState } from "react";
import { TOSModal } from "./TOSModal";
import { VOA_StepCodes } from "utilities/Constant";
import { trackOPTOptedVerification, trackOPTVerificationStepLoaded } from "utilities/optimizely";
import { VerificationType } from "./verificationService";
import RadioButtonGroup from "components/ui/radiobutton/RadioButtonGroup";

export default function Verification() {
  const stepData = useSelector(getStepData);
  const { nextStepActions: stepActions, stepCodeText } = stepData;
  const [error, setError] = useState(false);
  const verificationType = VOA_StepCodes.includes(stepCodeText) ? VerificationType.VOA : VerificationType.VOI;
  const [selectedOption, setSelectedOption] = useState<string>("");

  const [updateApplication] = useSetApplicationStepAnswerMutation({
    fixedCacheKey: "updateApplication",
  });
  const applicationId = useSelector(getCurrentUserApplicationId);

  const handleSubmit = async (stepActionId: string) => {
    await updateApplication({
      id: applicationId,
      stepActionId,
    });
  };

  const [showAssetModal, setShowAssetModal] = useState<boolean>(false);
  const onAssetModalClose = () => {
    setSelectedOption("");
    toggleAssetModal();
  };
  const toggleAssetModal = () => {
    if (!showAssetModal) {
      trackOPTOptedVerification(verificationType);
    }
    setShowAssetModal(!showAssetModal);
  };

  const handleContinue = () => {
    if (selectedOption === "verification") {
      toggleAssetModal();
    } else if (selectedOption === "manual") {
      void handleSubmit(stepActions[1].stepActionId);
    }
  };

  const verificationText = verificationType == "VOA" ? "assets" : "income";

  useEffect(() => {
    trackOPTVerificationStepLoaded(verificationType);
  }, []);

  return (
    <div className="toc">
      {error && <div className="toc-error">AccountChek is unavailable at this time. Please enter your {verificationText} manually.</div>}
      <div className="toc-container1">
        <div className="toc-options">
          <div className="toc-popup">
            <TOSModal
              showAssetModal={showAssetModal}
              toggleAssetModal={toggleAssetModal}
              onAssetModalClose={onAssetModalClose}
              handleAssetModalError={(e) => setError(e)}
              verificationType={verificationType}
            />
          </div>
          <div className="toc-container">
            <div>
              <div className="verification-radio-buttons">
                {/* First radio button with subtext */}
                <div className="radio-option">
                  <RadioButtonGroup
                    options={[{ label: stepActions[0].label, value: "verification" }]}
                    onChange={(value) => value === "verification" && setSelectedOption("verification")}
                    initialValue={selectedOption === "verification" ? "verification" : ""}
                  />
                  <div className="radio-subtext">
                    Securely connect your bank for instant<span className="mobile-line-break"></span> verification. Fast, accurate, and
                    <span className="mobile-line-break"></span> encrypted
                  </div>
                </div>

                {/* Second radio button with subtext */}
                <div className="radio-option radio-option--second">
                  <RadioButtonGroup
                    options={[{ label: stepActions[1].label, value: "manual" }]}
                    onChange={(value) => value === "manual" && setSelectedOption("manual")}
                    initialValue={selectedOption === "manual" ? "manual" : ""}
                  />
                  <div className="radio-subtext radio-subtext--second">
                    Prefer to type it in? No problem. you can enter your asset details yourself.
                  </div>
                </div>
              </div>

              <div className="toc-container__button">
                <Button className="toc-container__button--continue" title="Continue" type="round" variant="primary" onClick={handleContinue} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
